<template>
  <div>
    <empty-reminder v-if="records.length === 0 && !loading"></empty-reminder>

    <div id="phone-records">
      <div class="phone-records-list" v-for="record in records">
        <p class="description">
          {{ $t('yourFriends') }} {{ record.nickname }} {{ $t('bought') }}
          {{ record.package_device_count }} {{ $tc('devices', record.package_device_count)}}
          {{ $t(record.package_name) }}{{ $t('plan') }}
          <template v-if="record.status === 'cancelled'">{{ $t('refunded') }}</template>
        </p>
        <p>{{ $t('amount') }}{{ $t(':') }}<span :class="{'cancelled': record.status === 'cancelled'}">{{ record.award_days }} {{ $tc('days', record.award_days) }}</span>
        </p>
        <p class="time">{{ $t('time') }}{{ $t(':') }}{{ record.created_at | createFormatTime(record.created_at) }}</p>
      </div>
    </div>

    <spinner :show="loading" class="spinner-component"></spinner>
    <back-to-top></back-to-top>
    <load-more :current-page="currentPage" :total-page="totalPage"
               :loading="loading" @click.native="getAwardRecords"></load-more>
  </div>
</template>

<script>
  import {createFormatTime} from 'src/lib/filters'
  import EmptyReminder from '../EmptyReminder.vue'
  import Spinner from '../../Spinner.vue'
  import BackToTop from '../../backToTop/BackToTop.vue'
  import LoadMore from '../../loadMore/LoadMore.vue'
  import locales from './lang'

  export default {
    name: 'reward-record-m',
    components: {EmptyReminder, Spinner, LoadMore, BackToTop},
    props: ['initAwardRecordsData'],
    data: function () {
      return {
        records: [],
        currentPage: 0,
        totalPage: 1,
        loading: false
      }
    },
    locales,
    watch: {
      initAwardRecordsData() {
        this.records = this.records.concat(this.initAwardRecordsData.data)
        this.totalPage = Math.ceil(this.initAwardRecordsData.meta['total'] / this.initAwardRecordsData.meta['per_page'])
        this.currentPage = this.initAwardRecordsData.meta['current_page']
      }
    },
    methods: {
      getAwardRecords: function () {
        if (this.currentPage > this.totalPage) {
          return
        }
        this.currentPage++
        this.loading = true
        this.$http.get('api/award-records', {params: {'page': this.currentPage}}).then(response => {
          this.loading = false
          this.records = this.records.concat(response.data.data)
          this.totalPage = Math.ceil(response.data.meta['total'] / response.data.meta['per_page'])
        }, response => {
          this.loading = false
        })
      }
    },
    filters: {createFormatTime}
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../../assets/scss/variables";

  * {
    padding: 0;
    margin: 0;
  }

  .phone-records-list {
    padding: .16rem 0;
    &:not(:last-child) {
      border-bottom: 1px solid #EFEFEF;
    }
  }

  p {
    font-size: .14rem;
    line-height: .2rem;
    color: #333;
    margin-bottom: .12rem;
    letter-spacing: 0;

    &.time {
      font-size: .12rem;
      line-height: .18rem;
      color: #666;
      margin-bottom: 0;
    }

    .cancelled {
      text-decoration: line-through;
    }
  }

  .spinner-component {
    margin: 0 auto .1rem auto;
  }
</style>



// WEBPACK FOOTER //
// RewardRecordsM.vue?03a48ce9